import Store from 'redux/Store'
import displayError from './displayError'

interface displayGenErrorProps {
    setShowOverlay: Function
}

const displayGenError = (props: displayGenErrorProps) => {
    
   return displayError({
        errorMessage: 'An error has occurred.',
        setShowOverlay: props.setShowOverlay
   })
}

export default displayGenError